module.exports = __webpack_public_path__ + "static/media/project.0aa7cad0.jpg";